import { ChecksTabConfig } from 'helpers/useAccordionTab';

export const FILTER_SECTIONS = ['Filter Settings', 'Recipients'];
export const SETTINGS_SECTION_INDEX = 0;
export const RECIPIENTS_SECTION_INDEX = 1;

export const FILTER_PAGE_TYPE = 'filter';
export const FILTER_CHECKS_TAB: ChecksTabConfig = {
  [FILTER_PAGE_TYPE]: [['filter_name', 'filter_type'], ['recipients']],
};

export const FILTER_NOT_FOUND = "This filter doesn't exist for the selected client.";
